import React, { Component } from "react";
import { ListingContext } from "../../Context";
import SkeletonText from "../../components/skeleton/SkeletonText";

export default class ListingDescription extends Component {
  render() {
    return (
      <ListingContext.Consumer>
        {listingContext => {
          const listing = listingContext.listing || {};
          const description = listing.description || "";
          if (listingContext.loading) {
            return (
              <div className="listing-description">
                <SkeletonText lines={9} />
              </div>
            );
          } else if (!!description) {
            return (
              <div className="listing-description">
                <h5 className="listing-section__title">Description</h5>
                <p>{description}</p>
              </div>
            );
          } else {
            return null;
          }
        }}
      </ListingContext.Consumer>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/listing/ListingDescription.js